import {z} from 'zod'
import {publicFetch, resolvePublicApiBaseUrl} from '@fitro/customer-host/api'

const acceptedPassSchema = z.object({id: z.string().min(1), name: z.string().min(1), type: z.string().nullable(),
    entriesTotal: z.number().int().nonnegative().nullable(), isBenefit: z.boolean(), colorKey: z.string().nullable(), canUse: z.boolean()})
const pageSchema = z.object({number: z.number().int().nonnegative(), size: z.number().int().positive(),
    totalPages: z.number().int().nonnegative(), totalElements: z.number().int().nonnegative()})

/** The signed-in catalogue: entitlements only, priced by the customer's own purchase flow. */
export const acceptedPassPageSchema = z.object({content: z.array(acceptedPassSchema), page: pageSchema})

export const publicAcceptedPassPageSchema = z.object({
    content: z.array(acceptedPassSchema.extend({
        priceMinor: z.number().int().nonnegative(), currency: z.string().min(1), validityDays: z.number().int().nonnegative().nullable(),
        benefitProvider: z.string().nullable(),
        // The pricing page's public promotion preview, so a pass costs the same in both places.
        automaticPromotion: z.object({name: z.string().nullable(), discountAmountMinor: z.number().int().nonnegative(),
            finalAmountMinor: z.number().int().nonnegative(), lowestPrice30dMinor: z.number().int().nonnegative().nullable()}).nullable(),
    })),
    page: pageSchema,
})
export async function getPublicAcceptedPasses(slug: string, eventId: string, page: number, signal?: AbortSignal) {
    const baseUrl = resolvePublicApiBaseUrl()
    if (!slug || !eventId || !baseUrl) throw new Error('Public offer unavailable')
    const response = await publicFetch(`${baseUrl}/api/public/partners/${encodeURIComponent(slug)}/events/${encodeURIComponent(eventId)}/accepted-passes?page=${page}&size=24`, {
        method: 'GET', credentials: 'omit', cache: 'no-store', signal,
    })
    if (!response.ok) throw new Error(`Public accepted passes request failed: ${response.status}`)
    return publicAcceptedPassPageSchema.parse(await response.json())
}
